import { render } from "./Agreement_en.vue?vue&type=template&id=1ec9713c&scoped=true&ts=true"
import script from "./Agreement_en.vue?vue&type=script&lang=ts"
export * from "./Agreement_en.vue?vue&type=script&lang=ts"

import "./Agreement_en.vue?vue&type=style&index=0&id=1ec9713c&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec9713c"]])

export default __exports__